export const CONNECTED_RESOLUTION_OVERLAY: Record<string, any> = {
  en: { connected: { confirmation: {
    acceptCorrection: "Accept correction",
    rejectCorrection: "Reject correction",
    acceptSuccess: "Correction accepted. Both match copies are updated.",
    rejectSuccess: "Correction rejected. Shared facts were not changed.",
    reviewPrompt: "Review the requested changes, then accept or reject them.",
  } } },
  el: { connected: { confirmation: {
    acceptCorrection: "Αποδοχή διόρθωσης",
    rejectCorrection: "Απόρριψη διόρθωσης",
    acceptSuccess: "Η διόρθωση έγινε αποδεκτή. Ενημερώθηκαν και τα δύο αντίγραφα του αγώνα.",
    rejectSuccess: "Η διόρθωση απορρίφθηκε. Τα κοινά στοιχεία δεν άλλαξαν.",
    reviewPrompt: "Έλεγξε τις προτεινόμενες αλλαγές και επίλεξε αποδοχή ή απόρριψη.",
  } } },
  es: { connected: { confirmation: {
    acceptCorrection: "Aceptar corrección",
    rejectCorrection: "Rechazar corrección",
    acceptSuccess: "Corrección aceptada. Se actualizaron ambas copias del partido.",
    rejectSuccess: "Corrección rechazada. Los datos compartidos no cambiaron.",
    reviewPrompt: "Revisa los cambios solicitados y luego acéptalos o recházalos.",
  } } },
  fr: { connected: { confirmation: {
    acceptCorrection: "Accepter la correction",
    rejectCorrection: "Refuser la correction",
    acceptSuccess: "Correction acceptée. Les deux copies du match ont été mises à jour.",
    rejectSuccess: "Correction refusée. Les données partagées n’ont pas changé.",
    reviewPrompt: "Vérifiez les modifications demandées, puis acceptez-les ou refusez-les.",
  } } },
  de: { connected: { confirmation: {
    acceptCorrection: "Korrektur akzeptieren",
    rejectCorrection: "Korrektur ablehnen",
    acceptSuccess: "Korrektur akzeptiert. Beide Matchkopien wurden aktualisiert.",
    rejectSuccess: "Korrektur abgelehnt. Die gemeinsamen Daten wurden nicht geändert.",
    reviewPrompt: "Prüfe die angeforderten Änderungen und akzeptiere oder lehne sie anschließend ab.",
  } } },
  it: { connected: { confirmation: {
    acceptCorrection: "Accetta correzione",
    rejectCorrection: "Rifiuta correzione",
    acceptSuccess: "Correzione accettata. Entrambe le copie della partita sono state aggiornate.",
    rejectSuccess: "Correzione rifiutata. I dati condivisi non sono cambiati.",
    reviewPrompt: "Controlla le modifiche richieste, quindi accettale o rifiutale.",
  } } },
  ja: { connected: { confirmation: {
    acceptCorrection: "修正を承認",
    rejectCorrection: "修正を拒否",
    acceptSuccess: "修正を承認しました。両方の試合記録が更新されました。",
    rejectSuccess: "修正を拒否しました。共有データは変更されていません。",
    reviewPrompt: "修正内容を確認して、承認または拒否してください。",
  } } },
};
